import { AfterViewInit, Component, signal, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import '@iframe-resizer/child';
import { SpinnerComponent } from "./core/components/spinner/spinner.component";
import { ToastComponent } from './shared/components/toast/toast.component';
import { ToastService } from './core/services/toast.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit{
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild(SpinnerComponent) spinnerComponent?: SpinnerComponent;
  protected readonly title = signal('informe-rendimento');

  constructor(
    private toastService: ToastService,
   
  ) { }

  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
  
}
